import React from "react";
import Page from "../../../../layout/web/Page";
import Title from "../../../../components/Common/Title";
import Connector from "../../../../redux/connector";
import {GetUserToken} from "../../../../api/token";
import PluginAddDeleteList from "../../../../components/General/PluginAddDeleteList";
import {PostToPbx} from "../../../../api/http-post";


class UtilProjectPriorityPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Data:[],
            Modules:[],
            Products: [],
            isLoading: false,
            component: "list",
            newEntry:{},
        }
    }

    componentDidMount = async () => {

        await this.loadInitialData()
    }

    loadInitialData=async () => {
        /*
        await this.loadData("insurer","Insurers");
        await this.loadData("product","Products")
        */
    }
    loadData=async (targetEntity,stateKey)=>{
        let _this = this;
        let userInfo = GetUserToken();
        let table = targetEntity;
        let hub = {};
        hub.Org = userInfo.Org;
        let post = {}
        post.AutoGenerate = false;
        post.HasUniqueKey = false;
        post.AutoGenerateField = "";
        post.Data = {};
        post.Params = {}
        post.Entity = table;
        let endpoint = "/common/entity/" + table + "/list";
        this.setState({
            isLoading: true,
        })

        await PostToPbx(post, endpoint, async (data) => {
            console.log("SettingSetupSitePage loadInitialData response > ", post, " > ", data);
            let res=[];
            if(data!==null){
                res=data.RESULT
            }
            await _this.setState({
                [stateKey]: res
            });
        });
    }



    render() {

        return (
            <Page {...this.props}>
                <div style={{
                    minHeight: "100%",
                    maxHeight: "100%",
                }}>
                    <Title style={styles.title}>Util project priority</Title>
                    <div style={{minWidth: "100%", padding: 10}}>
                        <PluginAddDeleteList
                            _this={this}
                            targetEntity={"Priorities"}
                            fields={[
                                {name: "name", dataType: "string", required: true, label: "Name", options: []},
                                {name: "color", dataType: "string", required: true, label: "Color code", options: []},
                                {name: "position", dataType: "float", required: true, label: "Position", options: []},
                            ]}
                            deleteKeys={[
                                {key:"org",type:"string"},
                                {key:"module",type:"string"},
                                {key:"name",type:"string"},
                            ]}
                            stateArray={"Data"}
                            table={"Priorities"}
                            addFormText={"Priority"}
                            stepTitle={"Set Up new priority"}
                            displayRules={[
                                {rowKey:"org",stateKey:"selectedCompany"},
                                {rowKey:"module",stateKey:"selectedProject"}
                            ]}
                            filterByCompany={true}
                            filterByModule={true}
                            injectFields={[
                                {rowKey:"Org",stateKey:"selectedCompany",errorMsg:"Sorry you can't save, Please select your company!"},
                                {rowKey:"Module",stateKey:"selectedProject",errorMsg:"Sorry you can't save, Please select your Project!"}
                            ]}
                        />
                    </div>
                </div>
            </Page>
        )
    }

}


export default Connector(UtilProjectPriorityPage);

const styles = {
    container:{

    },
    title: {
        minWidth: "100%",
        borderBottomWidth: 1,
        borderColor: "gray"
    }
}
